import React from 'react';
import { Snackbar, Paper, Typography, IconButton, Stack, Box, Alert } from '@mui/material';
import { CallEnd, ScreenShare, StopScreenShare } from '@mui/icons-material';
import { HiOutlinePhoneMissedCall } from "react-icons/hi";
import { LuScreenShareOff } from "react-icons/lu";
import { LuScreenShare } from "react-icons/lu";
export function InCallNotification({ open, onClose, endCall, onToggleScreenShare, isScreenSharing, isVideoCall,setInCallNotification,inCallNotification,callTypeRef,toggleScreenShare, }) {
  return (
    <Snackbar
        open={inCallNotification}
        onClose={() => setInCallNotification(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={null} // Notification remains until call is answered or declined
      >
        <Alert
          onClose={() => setInCallNotification(false)}
          severity="info"
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
             Call
          </Box>
          <Box sx={{ display: "flex", gap: 1 }}>
            {callTypeRef?.current === "video" && (
                  <IconButton onClick={toggleScreenShare}>
                    <img
                      style={{ width: "30px", height: "30px" }}
                      src={
                        isScreenSharing
                          ? <LuScreenShareOff />
                          : <LuScreenShare />
                          
                      }
                      alt="Screen Share"
                    />
                  </IconButton>
                )}

            <IconButton onClick={endCall} color="error">
              <HiOutlinePhoneMissedCall />
            </IconButton>
          </Box>
        </Alert>
      </Snackbar>
  );
}

